/* eslint-disable react/prop-types */
import dayjs from 'dayjs';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { tooltipFormatter } from 'helpers/echart-utils';
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types';
import React from 'react';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LineChart,
  CanvasRenderer,
  LegendComponent
]);

const getOptions = (series, xAxis) => ({
  color: [getColor('primary'), getColor('secondary'), getColor('info')],
  tooltip: {
    trigger: 'axis',
    padding: [7, 10],
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-300'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    transitionDuration: 0,
    formatter: tooltipFormatter
  },
  xAxis: {
    type: 'category',
    data: xAxis,
    boundaryGap: false,
    silent: true,
    axisPointer: {
      lineStyle: {
        color: getColor('gray-300')
      }
    },
    splitLine: { show: false },
    axisLine: {
      lineStyle: {
        color: getColor('gray-400'),
        type: 'dashed'
      }
    },
    axisTick: {
      show: true,
      length: 20,
      lineStyle: {
        color: getColor('gray-200')
      },

      interval: 5
    },
    axisLabel: {
      color: '#87848A',
      align: 'left',
      fontSize: 11,
      padding: [0, 0, 0, 5],
      showMaxLabel: false
    }
  },
  yAxis: {
    type: 'value',
    position: 'right',
    axisPointer: { show: false },
    splitLine: {
      lineStyle: {
        color: getColor('gray-400'),
        type: 'dashed'
      }
    },
    axisLabel: {
      show: true,
      color: '#87848A'
    },
    axisTick: { show: false },
    axisLine: { show: false }
  },
  series,
  grid: {
    containLabel: true,
    right: '5px',
    left: 0,
    bottom: 0,
    top: 10
  }
});

const AirQualityChart = ({ data, xAxis }) => {
  const series = [];

  const color = [getColor('primary'), getColor('secondary'), getColor('info')];
  data.map((item, index) => {
    const { label, lineData } = item;
    series.push({
      type: 'line',
      name: label,
      data: lineData,
      showSymbol: false,
      symbol: 'circle',
      itemStyle: {
        borderColor: color[index],
        borderWidth: 2
      },
      lineStyle: {
        color: color[index]
      },
      symbolSize: 2
    });
  });

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getOptions(series, xAxis)}
      style={{ height: '16.25rem' }}
    />
  );
};

AirQualityChart.propTypes = {
  data: PropTypes.array
};

export default AirQualityChart;
